module.exports = __webpack_public_path__ + "img/economy.8e4d1329.jpg";